<template>
    <div>
        <div v-for="(item, idx) in items" :key="idx" :class="idx > 0 ? 'mt-3' : ''">
            <v-row v-for="field in fields" :key="field.id">
                <v-col cols="5" class="label pb-1 pt-1">{{ field.title }}</v-col>
                <v-col cols="7" class="value pb-1 pt-1">
                    {{ formatCustomFieldValue(item[field.name], field) }}
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import AppModule from "../../store/modules/app";
import { computed } from "@vue/composition-api";
import {formatCustomFieldValue} from "../../composables/use-custom-fields";

export default {
    name: "FieldGroupChilds",
    props: {
        parentField: {
            type: Object,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        accountId: {
            type: Number,
            required: true
        }
    },
    setup(props) {
        const { custom_fields } = AppModule();

        const fields = computed(function() {
            if (custom_fields.value[props.accountId] === undefined)
                return [];
            let key = props.parentField.type.replace("suppliers.", "supplier.");
            return custom_fields.value[props.accountId].filter(x => x.related_type === key && x.name !== "parent_id");
        });

        return {
            fields,
            formatCustomFieldValue
        }
    }
}
</script>
